import { requests } from "../../../api/agent"

export default {
	create                : (params) => requests.post('/ResourceType/create', params),
	update                : (params) => requests.post('/ResourceType/update', params),
	delete                : (params) => requests.getWithParams('/ResourceType/delete', params),
	restore               : (params) => requests.getWithParams('/ResourceType/restore', params),
	getPaged              : (params) => requests.getWithParams('/ResourceType/getPaged', params),
    getPagedAll           : (params) => requests.getWithParams('/ResourceType/getPagedAll', params),
	getPagedAudit         : (params) => requests.getWithParams('/ResourceType/getPagedAudit', params)
}